import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import {
  clearTypoCheckFromStorage,
  getTypoCheckFromStorage,
  setTypoCheckToStorage,
} from '@src/modules/local_storage_utils';
import type { RootState } from '@src/store';

type TypoCheckState = {
  enabled: boolean;
  runningCount: number;
};

const initialState: TypoCheckState = {
  enabled: getTypoCheckFromStorage(),
  runningCount: 0,
};

const typoCheckSlice = createSlice({
  name: 'typoCheck',
  initialState,
  reducers: {
    setTypoCheckEnabled(state, action: PayloadAction<boolean>) {
      state.enabled = action.payload;
      setTypoCheckToStorage(state.enabled);
    },
    toggleTypoCheck(state) {
      state.enabled = !state.enabled;
      setTypoCheckToStorage(state.enabled);
    },
    resetTypoCheck(state) {
      state.enabled = true;
      clearTypoCheckFromStorage();
    },
    incrementTypoCheckRunning(state) {
      state.runningCount += 1;
    },
    decrementTypoCheckRunning(state) {
      state.runningCount = Math.max(0, state.runningCount - 1);
    },
  },
});

export const {
  toggleTypoCheck,

  incrementTypoCheckRunning,
  decrementTypoCheckRunning,
} = typoCheckSlice.actions;

export const selectTypoCheckEnabled = (state: RootState) => state.typoCheck.enabled;
const _selectTypoCheckRunning = (state: RootState) => state.typoCheck.runningCount > 0;
const _selectTypoCheckRunningCount = (state: RootState) => state.typoCheck.runningCount;

export default typoCheckSlice.reducer;
